import React, { createContext, useContext, useState, useCallback } from "react";

interface SignUpModalContextValue {
  isSignUpModalOpen: boolean;
  setSignUpModalOpen: (open: boolean) => void;
}

const SignUpModalContext = createContext<SignUpModalContextValue | null>(null);

export const useSignUpModal = () => {
  const ctx = useContext(SignUpModalContext);
  if (!ctx) {
    throw new Error("useSignUpModal must be used within SignUpModalProvider");
  }
  return ctx;
};

interface SignUpModalProviderProps {
  children: React.ReactNode;
}

export const SignUpModalProvider: React.FC<SignUpModalProviderProps> = ({
  children,
}) => {
  const [isSignUpModalOpen, setSignUpModalOpen] = useState(false);
  const setOpen = useCallback((open: boolean) => setSignUpModalOpen(open), []);
  return (
    <SignUpModalContext.Provider
      value={{ isSignUpModalOpen, setSignUpModalOpen: setOpen }}
    >
      {children}
    </SignUpModalContext.Provider>
  );
};
